<template>
  <div>
    <div class="row flex-nowrap">
      <field-metrics v-for="(dateAdded, index) in views" :key="dateAdded"
        :compare="{ index, dateAdded, add, remove, length }"
        class="col field-metrics-item"
        :style="{ width: (100 / views).toPrecision(2) + '%' }"
        data-name="fieldMetrics"
      ></field-metrics>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from '@/utils'
import FieldMetrics from "@/components/insights/FieldMetrics.vue";

export default {
  name: 'FieldMetricsWrapper',
  metaInfo: {
    title: 'Field metrics'
  },
  components: {FieldMetrics},
  data () {
    return {
      views: [
        new Date().toISOString() // value does not matter
      ]
    }
  },
  mounted () { },
  computed: {
    comparisonViews () {
      return [...this.views].sort((a, b) => new Date(a) - new Date(b))
    }
  },
  methods: {
    cloneDeep,
    add (index = 0) {
      this.views.splice(index + 1, 0, new Date().toISOString())
      this.$forceUpdate()
    },
    remove (index) {
      this.views.splice(index, 1)
    },
    length () {
      return this.views.length
    }
  }
}
</script>

<style>
.field-metrics-item {
  min-width: 600px;
  @media (max-width: 600px) {
    min-width: 100%;
  }
}
body, html {
  overflow-x: auto !important;
}
</style>
